import styled from 'styled-components';

// container used in both holiday information page and the summary widget
export const BoxRight = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;

  .priceHeader {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }

  .comboTitle {
    font-weight: 600;
    font-size: 14px;
  }

  .comboDesc {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
  }

  .comboPrice {
    text-align: right;
    max-width: 50%;
  }

  .comboPrice .total {
    font-weight: 600;
    font-size: 14px;
  }

  .comboPrice .per {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
  }

  .divider {
    height: 1px;
    background: #e5e5e5;
    margin: 16px 0;
  }
  .payment {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }
  .paymentLabel {
    font-size: 16px;
    font-weight: 700;
  }
  .paymentPrice {
    font-size: 22px;
    font-weight: 700;
    text-align: right;
    max-width: 70%;
    color: var(--color-9);
  }
`;

export const NoteBox = styled.div`
  margin-top: 20px;
  background: #f5f5f5;
  border-radius: 12px;
  padding: 12px;
`;

export const NoteTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
`;

export const NoteContent = styled.div`
  font-size: 12px;
  color: #555;
  margin-top: 6px;
  line-height: 1.5;
`;
